import { useState } from "react"

export const Call = () => {
    // call
    const [callmodal, setCallModal] = useState({toggled: false, id: ""})
    const [callConfirmmodal, setCallConfirmModal] = useState({modal:{toggled:false, confirmed:false}})
    const [callMonitoring, setCallMonitoring] = useState({
		submit:{method: "create", type: 1},
		id: null,
		offer_type: { value: '', stat: false, msg: '' },
		mobile_number: { value: '', stat: false, msg: '' },
		telephone_number: { value: '', stat: false, msg: '' },
		last_name: { value: '', stat: false, msg: '' },
		first_name: { value: '', stat: false, msg: '' },
		company_name: { value: '', stat: false, msg: '' },
		email: { value: '', stat: false, msg: '' },
		address: { value: '', stat: false, msg: '' },
		call_date: { value: '', stat: false, msg: '' },
		call_time: { value: '', stat: false, msg: '' },
		call_time_ended: { value: '', stat: false, msg: '' },
		call_duration: { value: '', stat: false, msg: '' },
		remarks: { value: '', stat: false, msg: '' },
		call_status_id: { value: '', stat: false, msg: '' },
		date_for_call: { value: '', stat: false, msg: '' },
		time_for_call: { value: '', stat: false, msg: '' },
		contact_id: { value: '', stat: false, msg: '' },
		nature_of_business: { value: '', stat: false, msg: '' },
		position: { value: '', stat: false, msg: '' },
		source_of_leads: { value: '', stat: false, msg: '' },	
		current_use: { value: '', stat: false, msg: '' },
    })
    const dfltCall = {
        submit:{method: "create", type: 1},
        id: null,
        offer_type: { value: '', stat: false, msg: '' },
        mobile_number: { value: '', stat: false, msg: '' },
        telephone_number: { value: '', stat: false, msg: '' },
        last_name: { value: '', stat: false, msg: '' },
        first_name: { value: '', stat: false, msg: '' },
        company_name: { value: '', stat: false, msg: '' },
        email: { value: '', stat: false, msg: '' },
        address: { value: '', stat: false, msg: '' },
        call_date: { value: '', stat: false, msg: '' },
        call_time: { value: '', stat: false, msg: '' },
        call_time_ended: { value: '', stat: false, msg: '' },
        call_duration: { value: '', stat: false, msg: '' },
        remarks: { value: '', stat: false, msg: '' },
        call_status_id: { value: '', stat: false, msg: '' },
        date_for_call: { value: '', stat: false, msg: '' },
        time_for_call: { value: '', stat: false, msg: '' },
        contact_id: { value: '', stat: false, msg: '' },
		nature_of_business: { value: '', stat: false, msg: '' },
		position: { value: '', stat: false, msg: '' },
		source_of_leads: { value: '', stat: false, msg: '' },	
		current_use: { value: '', stat: false, msg: '' },
     }
    const [callListView, setCallListView] = useState([])
    const [callLoader, setCallLoader] = useState(false)
    const [loader, setLoader] = useState(true)
    const [anchorElInfo, setAnchorInfo] = useState(null)
    const [error, setError] = useState('');
	const [filter, setFilter] = useState({ search: '' })
	const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)

    // Offer type
    const [offerType, setOfferType] = useState({toggle: false, topic: '', active: true, error: false, msg: '', disabled: false, snackbar: false})
    const [offerList, setOfferList] = useState([])
    const [reviewCall, setReviewCall] = useState(false)
	
	const [natureOfBusiness, setNatureOfBusiness] = useState([]);
	const [companyPositions, setCompanyPositions] = useState([]);
	const [sourceOfLeads, setSourceOfLeads] = useState([]);

    return {
        // call
        callmodal: {data: callmodal, set: setCallModal},
        callConfirmmodal: {data: callConfirmmodal, set: setCallConfirmModal},
        callMonitoring:{data:callMonitoring, set: setCallMonitoring},
        callListView: {data:callListView, set: setCallListView},
        callLoader: {data:callLoader, set: setCallLoader},
        loader: {data:loader, set: setLoader},
        anchorElInfo: {data:anchorElInfo, set: setAnchorInfo},
        error: {data:error, set: setError},
		filter: {data: filter, set: setFilter},
		page: {data: page, set: setPage},
		hasMore: {data: hasMore, set: setHasMore},
        reviewCall: {data: reviewCall, set: setReviewCall},
        // Offer type
        offerType: {data:offerType, set: setOfferType},
        offerList: {data: offerList, set: setOfferList},
        dfltCall: {data: dfltCall},
		natureOfBusiness: {data: natureOfBusiness, set: setNatureOfBusiness},
		companyPositions: {data: companyPositions, set: setCompanyPositions},
		sourceOfLeads: {data: sourceOfLeads, set: setSourceOfLeads},
    }
}